import React, { useEffect, useState } from "react";
import { trackGptClickOrder } from "../../consent/gptTracking";

const ORDER_NOW_URL = "https://order.simplysalad.com/";

export const MobileHomeOrderBar = ({ showImmediately = false }) => {
  const [show, setShow] = useState(showImmediately);

  useEffect(() => {
    if (showImmediately) {
      return;
    }

    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [showImmediately]);

  return (
    <div
      className={`pointer-events-none fixed inset-x-0 bottom-0 z-[15] md:hidden 
      transition-transform duration-300 ease-in-out
      ${show ? "translate-y-0" : "translate-y-full"}`}
    >
      <div
        className="pointer-events-auto border-t border-black/10 bg-white px-3 pt-2 shadow-[0_-8px_24px_rgba(0,0,0,0.08)]"
        style={{
          paddingBottom: "max(0.75rem, env(safe-area-inset-bottom, 0px))",
        }}
      >
        <a
          href={ORDER_NOW_URL}
          target="_self"
          rel="noopener noreferrer"
          className="flex h-12 w-full items-center justify-center rounded border border-primary bg-primary-gradient hover:bg-black text-lg font-bold !text-white transition-opacity hover:opacity-95 active:opacity-90"
          onClick={() =>
            trackGptClickOrder({
              linkUrl: ORDER_NOW_URL,
              ctaLocation: "mobile_bar",
            })
          }
        >
          <span aria-hidden="true">🥗</span>
          <span className="ml-1">Order Now</span>
          <span className="sr-only">, opens Simply Salad ordering</span>
        </a>
      </div>
    </div>
  );
};
